export default function RadioOptions({ identifier, mandatory, value, onChange, options = [], disabled }) {
    /**
     * RadioOptions Component
     *
     * Props:
     * @param {string} identifier - The unique name/identifier for the radio group.
     * @param {boolean} mandatory - Whether the input is required (adds `required` attribute).
     * @param {string} value - The currently selected value for the radio group.
     * @param {function} onChange - Callback function triggered when the value changes.
     * @param {Array} options - Array of options for the radio buttons. Each option should be an object with `value` and `label` properties.
     * @param {boolean} [disabled=false] - Whether the radio buttons are disabled.
     *
     * Example Usage:
     * <RadioOptions
     *     identifier="example"
     *     mandatory={true}
     *     value={selectedValue}
     *     onChange={(e) => setSelectedValue(e.target.value)}
     *     options={[
     *         { value: "1", label: "Option 1" },
     *         { value: "2", label: "Option 2" },
     *     ]}
     *     disabled={false}
     * />
     */
    
    const createOptions = () => {
        return options.map((item, index) => (
            <div className="radio-option" key={index}>
                <input
                    type="radio"
                    name={identifier}
                    id={`${identifier}-${index}`}
                    className={`radio-option-input default-input`}
                    value={item.value}
                    onChange={onChange}
                    required={mandatory}
                    checked={value === item.value}
                />
                <label htmlFor={`${identifier}-${item.value}`} className="radio-option-label">
                    {item.label}
                </label>
            </div>
        ));
    };

    return (
        <div className={"radio-option-container fade-in " + (mandatory ? "mandatory-input" : "")}>

            {createOptions()}
        </div>
    );
}